import Config from './api-access.router';
import options from './api-access.component';

const Component = {
    selector: 'dtApiAccessView',
    options
};

export {
    Config,
    Component
};



// WEBPACK FOOTER //
// ./app/components/developer-settings/api-access/index.js